// src/App.js
import React from 'react';
import ThemeContextProvider from './contexts/ThemeContext';
import Login from './Login';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/home/Home';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';

const App = () => {
  return (
    <ThemeContextProvider>
      <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login/>} />
          <Route path="/*" element={ <PrivateRoute><Home /></PrivateRoute>} />
        </Routes>
      </Router>
      </AuthProvider>
    </ThemeContextProvider>
  );
};

export default App;
